import styled from 'styled-components';
import colors from '../../../../../styles/colors';
import { heightContent, widthImageContent } from '../styles';

export const Container = styled.div`
    padding: 60px 5px 0 110px;
    display: flex;
    flex-direction: column;
    width: calc(100% - ${widthImageContent}px - 182px);
    height: calc(${heightContent}px - 100px);
`;

export const Title = styled.p`
    font-size: 27px;
    color: ${colors.color_3F577B};
`;

export const UnderlinedTitle = styled.div`
    width: 150px;
    height: 3px;
    background-color: ${colors.color_4BB493};
`;

export const InputsContent = styled.div`
    margin-top: 35px;
    padding-bottom: 10px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: stretch;
    flex-wrap: wrap;
    gap: 30px 14px;
    width: 100%;
    max-height: 500px;

    @media (max-width: 1537px) {
        overflow-y: scroll;

        ::-webkit-scrollbar {
            width: 7px;
            height: 7px;
        }

        ::-webkit-scrollbar-thumb {
            background: ${colors.color_3F577B};
            border-radius: 5px;
            transition: 0.5s;
        }

        ::-webkit-scrollbar-track {
            background: ${colors.color_F5F6F8};
            border: 1px solid ${colors.color_BCE0FD};
            border-radius: 5px;
        }
    }
`;
